import { render, staticRenderFns } from "./IndustryReport.vue?vue&type=template&id=bbc71c7c&scoped=true&"
import script from "./IndustryReport.vue?vue&type=script&lang=js&"
export * from "./IndustryReport.vue?vue&type=script&lang=js&"
import style0 from "./IndustryReport.vue?vue&type=style&index=0&id=bbc71c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc71c7c",
  null
  
)

export default component.exports